import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/ApiEndpoints";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

// App_Setup - Get All (Read)
export const GetAll = createAsyncThunk(
  "user/user/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.User_Management.User}?first_name=${filter?.first_name ||
          ""}&last_name=${filter?.last_name || ""}&email=${filter?.email ||
          ""}&contact_no=${filter?.contact_no ||
          ""}&role_id=${filter?.role_id || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// User - Get (Read)
export const GetSingle = createAsyncThunk(
  "user/user/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.User_Management.User}/${id}`);
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// User - Create (Add)
export const Create = createAsyncThunk(
  "user/user/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.User_Management.User, data);
      return res; // The new user object
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

// User - Update
export const Update = createAsyncThunk(
  "user/user/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.User_Management.User}/${id}`, data);
      return res;
    } catch (error) {
      return rejectWithValue(error.response?.status);
    }
  },
);

// User - Delete
export const Delete = createAsyncThunk(
  "user/user/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.User_Management.User}/${id}`);
      return id; // Return the id of the deleted user
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

//  Status
export const Status = createAsyncThunk(
  "user/user/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.User_Management.User}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "users",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Create.rejected, (state, action) => {
        console.log(action, "action");

        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Status.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Status.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload;
        // state.data = state.data.filter(
        //   (user) => user.id !== action.payload.id
        // ); // Remove the user with the deleted id
      })
      .addCase(Status.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
